<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="">
        <el-form-item label="关键字" class="kw">
          <el-input
            placeholder="请输入"
            v-model="searchData.keywordsValue"
            clearable
            class="input-with-select"
            size="small"
          >
            <el-select
              v-model="searchData.keywordsName"
              slot="prepend"
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in searchTypeCount"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="search"
            >搜索</el-button
          >
          <el-button
            type="info"
            size="small"
            icon="el-icon-refresh"
            @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>

    <tp-table
      :isNeedSerialNumber="true"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />

    <ReduceAmount
      v-if="dialogType == 'reduceAmount'"
      ref="reduceAmount"
      :orderNo="orderNo"
      @update="getList"
    />

    <OfflinePay
      v-if="dialogType == 'offlinePay'"
      ref="offlinePay"
      :orderNo="orderNo"
      @update="getList"
    />

    <!-- 设备监管 -->
    <el-dialog title="设备监管" :visible.sync="show_lock" width="800px">
      <el-form ref="formLock" :model="lockData" label-width="130px">
        <div class="lock-info">
          <span>订单号：{{ lockData.orderNo }}</span>
          <span>客户姓名：{{ lockData.memberName }}</span>
          <span>手机号：{{ lockData.memberMobile }}</span>
        </div>
        <el-form-item label="上次锁机日：">{{ lockData.beforeLockDate }}</el-form-item>
        <el-form-item label="设备状态：">
          <el-select
            style="width: 220px"
            v-model="lockData.lockStatus"
            placeholder="请选择"
            clearable
            size="mini"
          >
            <el-option label="未锁机" :value="0"></el-option>
            <el-option label="待锁机" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="lockData.lockStatus == 1" label="待锁机日期：">
          <el-date-picker
            style="width: 220px"
            v-model="lockData.lockDate"
            value-format="yyyy-MM-dd"
            size="mini"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <span style="color: #f56c6c; margin-left: 15px"
            >（ 注意：只能选当天及以后日期 ）</span
          >
        </el-form-item>
        <el-form-item v-if="lockData.lockStatus == 1" label="延期锁机服务费：">
          <el-input-number
            style="width: 220px"
            v-model="lockData.lockFee"
            size="small"
            :controls="false"
            :min="0.00"
          ></el-input-number>
        </el-form-item>
      </el-form>

      <OrderBillList :key="show_lock" :orderNo="lockData.orderNo" />

      <div slot="footer">
        <el-button @click="show_lock = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitLock" size="mini">提 交</el-button>
      </div>
    </el-dialog>

    <!-- 账单挂账 -->
    <el-dialog title="订单挂账" :visible.sync="show_reserve" width="900px">
      <el-form
          ref="formReserve"
          :model="reserveData"
          label-width="140px"
          :rules="reserveRules"
      >
        <el-form-item label="订单号：">
          <span>{{ reserveData.orderNo }}</span>
        </el-form-item>
        <el-form-item label="客户姓名：">
          <span>{{ reserveData.memberName }}</span>
        </el-form-item>
        <el-form-item label="手机号：">
          <span>{{ reserveData.memberMobile }}</span>
        </el-form-item>
        <el-form-item label="挂账余额：">
          <span>{{ reserveData.reserveAmount || "0.00" }} 元</span>
        </el-form-item>
        <el-form-item label="挂账变动类型：" prop="reserveType">
          <el-select
              v-model="reserveData.reserveType"
              placeholder="请选择挂账变动类型"
              style="width: 220px"
          >
            <el-option
                v-for="item in reserveTypeOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="本次调整金额：" prop="amount">
          <div style="display: flex; align-items: center; width: 220px;">
            <el-input-number
                v-model="reserveData.amount"
                placeholder="请输入调整金额"
                style="flex: 1;"
                :precision="2"
                :min="0.01"
                :controls="false"
            />
            <span style="margin-left: 8px; color: #909399">元</span>
          </div>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
              v-model="reserveData.remark"
              type="textarea"
              placeholder="请输入备注信息（选填）"
              :rows="3"
              style="width: 100%"
          ></el-input>
        </el-form-item>
      </el-form>

      <OrderReserveList :key="show_reserve" :orderNo="reserveData.orderNo" />

      <div slot="footer">
        <el-button @click="show_reserve = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitReserve" size="small">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import { searchTypeCount } from "@/enum/dict/index.js";
import { getFinanceOrderListAPI, exportAPI, submitLockAPI, addReserveAPI } from "./api";
import ReduceAmount from "./reduce-amount.vue";
import OfflinePay from "./offline-pay.vue";
import {
  getWithholdChannelText,
  getWithholdChannelType,
  shouldShowWithholdChannel,
} from "@/enum/dict/withholdChannel";
import OrderBillList from "@/components/order-bill/index.vue";
import OrderReserveList from "@/components/order-reserve/index.vue";

const columns = [
  {
    label: "用户信息",
    prop: "member",
    minWidth: "200",
    customRender(h, row) {
      return (
        <div>
          <p>姓名：{row["member"]?.["memberName"]}</p>
          <p>手机号：{row["member"]?.["mobile"]}</p>
        </div>
      );
    },
  },
  {
    label: "订单号",
    prop: "orderNo",
    minWidth: "300",
    customRender(h, row) {
      return (
        <div>
          <span>{row["orderNo"]}</span>
          <el-tag
              v-show={shouldShowWithholdChannel(row["withholdChannel"])}
              type={getWithholdChannelType(row["withholdChannel"])}
              size="mini"
              style="margin-left: 5px"
          >
            {getWithholdChannelText(row["withholdChannel"])}
          </el-tag>
        </div>
      );
    },
  },
  {
    label: "审核",
    prop: "reviewUserName",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["reviewUser"]?.["userName"]}</p>;
    },
  },
  {
    label: "客服",
    prop: "kfUserName",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["kfUser"]?.["userName"]}</p>;
    },
  },
  {
    label: "设备监管",
    prop: "device",
    minWidth: "200",
    customRender(h, row) {
      return (
        <p>
          <div>
            锁机状态：
            <el-tag v-show={row["lockStatus"] == 0} type="success" size="mini">
              未上锁
            </el-tag>
            <el-tag v-show={row["lockStatus"] == 1} type="warning" size="mini">
              待上锁
            </el-tag>
            <el-tag v-show={row["lockStatus"] == 2} type="danger" size="mini">
              已上锁
            </el-tag>
          </div>
          <div>
            待锁机日期：{row["lockDate"] || "无"}
          </div>
        </p>
      );
    },
  },
  {
    label: "成本",
    prop: "costPrice",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["costPrice"]}</p>;
    },
  },
  {
    label: "挂账余额",
    prop: "reserveAmount",
    minWidth: 100,
    customRender(h, row) {
      return <p>{row["reserveAmount"] || "0.00"}</p>;
    },
  },
  {
    label: "下单时间",
    prop: "createTime",
    minWidth: "180",
    customRender(h, row) {
      return <p>{row["createTime"]}</p>;
    },
  },
  {
    label: "订单状态",
    prop: "statusName",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["statusName"]}</p>;
    },
  },
  {
    label: "操作",
    minWidth: "220",
    fixed: "right",
    customRender(h, row) {
      return (
        <div>
          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.finance_order_list_offline_pay)}
            style="margin:0 5px;"
            underline={false}
            type="primary"
            onClick={() => this.handleShowDialog("offlinePay", row["orderNo"])}
          >
            线下还款
          </el-link>

          <el-link
              disabled={!this.isShowBtn(this.AUTH_BTN.finance_order_list_order_reserve)}
              style="margin:0 5px;"
              underline={false}
              type="primary"
              onClick={() => this.handleReserve(row)}
          >
            订单挂账
          </el-link>

          <el-link
            v-show={row.status == 6 || row.status == 7}
            disabled={!this.isShowBtn(this.AUTH_BTN.finance_order_list_device_lock)}
            underline={false}
            type="primary"
            onClick={() => this.handleLock(row)}
          >
            设备监管
          </el-link>
        </div>
      );
    },
  },
];

export default {
  name: "FinanceOrderList",
  mixins: [authBtnMixin],
  components: { ReduceAmount, OfflinePay, OrderBillList, OrderReserveList },
  data() {
    return {
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        keywordsName: "",
        keywordsValue: "",
      },
      searchTypeCount,
      dialogType: "",
      orderNo: "",
      // 设备监管
      lockData: {
        orderNo: "",
        memberName: "",
        memberMobile: "",
        lockStatus: 0,
        beforeLockDate: "",
        lockDate: "",
        lockFee: undefined,
      },
      show_lock: false,
      pickerOptions: {
        disabledDate(time) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24);
          return time.getTime() < date;
        },
      },
      // 账单挂账
      reserveData: {
        orderNo: "",
        memberName: "",
        memberMobile: "",
        reserveAmount: "",
        reserveType: "",
        amount: "",
        remark: "",
      },
      show_reserve: false,
      reserveRules: {
        reserveType: [
          { required: true, message: "请选择挂账变动类型", trigger: "change" },
        ],
        amount: [
          { required: true, message: "请输入调整金额", trigger: "blur" },
          {
            type: "number",
            min: 0.01,
            message: "调整金额必须大于0",
            trigger: "blur",
          },
        ],
      },
      reserveTypeOptions: [
        { name: "新增挂账", value: 101 },
        { name: "减少挂账", value: 201 },
      ],
    };
  },
  provide() {
    return {
      context: this,
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  methods: {
    // 设备监管
    handleLock(row) {
      this.lockData = {
        orderNo: row.orderNo,
        memberName: row.member.memberName,
        memberMobile: row.member.mobile,
        lockStatus: 1,
        beforeLockDate: row.lockDate,
        lockDate: '',
        lockFee: undefined,
      };
      this.show_lock = true;
    },
    // 提交设备监管
    submitLock() {
      const { orderNo, lockStatus, lockDate, lockFee } = this.lockData;
      let data = {};
      if (lockStatus == 1) {
        if (!lockDate) return this.$message.error("请选择待锁机日期！");
        data = { orderNo, lockStatus, lockDate, lockFee };
      } else {
        data = { orderNo, lockStatus };
      }
      submitLockAPI(data).then(() => {
        this.$message.success("操作成功");
        this.getList();
        this.show_lock = false;
      });
    },
    search() {
      this.getList();
    },
    async getList() {
      const { keywordsName, keywordsValue } = this.searchData;
      if (!keywordsName && keywordsValue) return this.$message.error("请选择搜索类型！");
      let params = { page: this.currentPage, pageSize: this.pageSize };
      if (keywordsName) params[keywordsName] = keywordsValue;
      const res = await getFinanceOrderListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    downloadExcel() {
      const { keywordsName, keywordsValue } = this.searchData;
      let params = {};
      if (keywordsName) params[keywordsName] = keywordsValue;
      exportAPI(params);
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    },
    handleShowDialog(type, orderNo) {
      this.dialogType = type;
      this.orderNo = orderNo;
      this.$nextTick(() => {
        this.$refs[this.dialogType].outerVisible = true;
        if (type == "offlinePay") {
          this.$refs[this.dialogType].cashAmount = undefined;
          this.$refs[this.dialogType].reserveAmount = undefined;
        }
        this.$refs[this.dialogType].getOrderBillList();
      });
    },
    handleReserve(row) {
      this.reserveData = {
        orderNo: row.orderNo,
        memberName: row.member.memberName,
        memberMobile: row.member.mobile,
        reserveAmount: row.reserveAmount || "0.00",
        reserveType: 101,
        amount: undefined,
        remark: "",
      };
      this.show_reserve = true;
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.formReserve) {
          this.$refs.formReserve.clearValidate();
        }
      });
    },
    // 提交挂账
    submitReserve() {
      this.$refs.formReserve.validate((valid) => {
        if (valid) {
          const { orderNo, reserveType, amount, remark } = this.reserveData;
          const data = {
            orderNo,
            reserveType,
            amount: amount.toString(),
            remark: remark || "",
          };

          addReserveAPI(data)
              .then(() => {
                this.$message.success("挂账操作成功");
                this.show_reserve = false;
                this.getList();
              })
              .catch((error) => {
                // 提交失败时不关闭弹窗，让用户可以看到错误信息
                console.error("挂账操作失败:", error);
              });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 35px;
        .el-input {
          width: 350px;
        }
        .el-date-editor {
          .el-range-separator {
            padding: 0;
          }
          .el-range-input {
            width: 35%;
          }
        }
      }
      .kw {
        .el-select .el-input {
          width: 118px;
        }
        .el-select {
          width: 120px;
        }
        .input-with-select {
          vertical-align: middle;
          width: 320px;
        }
        .input-with-select .el-input-group__prepend {
          background-color: #fff;
        }
      }
    }
  }
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  .header-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }
  .el-dialog__body {
    padding-top: 0;
  }
  .lock-info {
    font-size: 16px;
    font-weight: 500;
    margin: 20px;
    >span {
      margin: 0 20px;
    }
  }
}
</style>
